import { useThree } from "@react-three/fiber";
import React, { useEffect, useState } from "react";
import { OrbitControls } from "@react-three/drei";
import { useClient } from "../../shared/hooks/client-hook";
import { MathUtils } from "three";

const FPSControls = () => {
  const { camera } = useThree();
  const [position, setPosition] = useState([0, 0, 0]);
  const [firstTimeAjusted, setFirstTimeAjusted] = useState(false);
  const height = 1.75;

  const { camPos, camRot } = useClient();

  useEffect(() => {
    const offset = [
      camera.position.x - position[0],
      camera.position.y - position[1],
      camera.position.z - position[2],
    ];

    camera.position.set(
      camPos[0] + offset[0],
      camPos[1] + offset[1] + height,
      camPos[2] + offset[2]
    );

    setPosition([camPos[0], camPos[1] + height, camPos[2]]);
  }, [camPos, camRot]);

  useEffect(() => {
    if (!firstTimeAjusted && camPos && camRot) {
      const r = camRot || 0;

      const xOffset = Math.sin(MathUtils.degToRad(r));
      const zOffset = Math.cos(MathUtils.degToRad(r));

      camera.position.set(
        camPos[0] + xOffset,
        camPos[1] + height,
        camPos[2] + zOffset
      );

      setFirstTimeAjusted(true);
    }
  }, [camPos, camRot, firstTimeAjusted]);

  return (
    <OrbitControls rotateSpeed={-1} target={position} enableZoom={false} />
  );
};

export default FPSControls;
